import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Navigate, Routes, Route, useLocation, useParams } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Private from "./component/Private";
import RequirePerm from "./component/RequirePerm";
import EndlineSetupPage from "./component/Endline2_Component/setup/EndlineSetupPage";

//************************/ DEPLOYED /************************//
const Home = React.lazy(() => import("./Home"));
const SettingHomePage = React.lazy(() =>
    import("./page/SettingHomePage/SettingHomePage")
);
const LoadDataSewing = React.lazy(() =>
    import("./component/LoadDataComponent/LoaddataSewing")
);
const ControlRoom = React.lazy(() => import("./Control_Room"));
const DashboardSewingComponent = React.lazy(() =>
    import("./component/Dashboard_SewingComponent/Dashboard_SewingComponent")
);
const DashboardQuality2Component = React.lazy(() =>
    import(
        "./component/Dashboard_Quality2Component/Dashboard_Quality2Component"
    )
);
const DashboardQuality1Component = React.lazy(() =>
    import(
        "./component/Dashboard_Quality1Component/Dashboard_Quality1Component"
    )
);

const CuttingDashboard = React.lazy(() =>
    import("./component/Cutting_DashboardComponent/Cutting_Dashboard")
);

const ReportEndline = React.lazy(() =>
    import("./page/ReportEndline/ReportEndline")
);
const OnTimeDelivery = React.lazy(() => import("./page/ontimedelivery"));

const SPFTracking = React.lazy(() =>
    import("./component/SPFTracking_Body/SPFTracking")
);
const ReportCPI = React.lazy(() => import("./page/ReportCPI/ReportCPI"));

const MasterPath = React.lazy(() => import("./page/MasterPath/MasterPath"));

const EndlineMainComponent = React.lazy(() =>
    import("./component/Endline_Component/Endline_MainComponent")
);
const Endline2MainComponent = React.lazy(() =>
    import("./component/Endline2_Component/Endline_MainComponent")
);

const ReportSPFComponent = React.lazy(() =>
    import("./component/Report_SPFComponent/Report_SPFComponent")
);

const SewingEfficiencyStatus = React.lazy(() =>
    import("./page/SewingEfficiencyStatus/SewingEfficiencyStatus")
);

const SubProcess = React.lazy(() => import("./page/subprocess"));
const Sm3FullScreenPage = React.lazy(() => import("./page/sm3"));
const Sm3NewPage = React.lazy(() => import("./page/sm3new"));
const Sm3New3Page = React.lazy(() => import("./page/sm3new3"));
const SubprocessNewLogicPage = React.lazy(() =>
    import("./page/SubprocessNewLogic")
);
const LegacySubprocessNew3Redirect = () => {
    const { bu } = useParams();

    return <Navigate replace to={bu ? `/subprocessnew/${bu}` : "/subprocessnew"} />;
};
const ReportFanatics = React.lazy(() =>
    import("./page/Report_Fanatics/ReportFanatics")
);

const ScanEMB = React.lazy(() => import("./page/QC/QC_EMB/ScanEMB"));
const ScanPrinting = React.lazy(() =>
    import("./page/QC/QC_Printing/ScanPrinting")
);
const Report_QC_System = React.lazy(() =>
    import("./page/Report_QC_System/Report_QC_System")
);

const Audit = React.lazy(() => import("./page/Audit/Audit"));
const Audit_2 = React.lazy(() => import("./page/Audit/Audit_2"));

const MatchingDashboard = React.lazy(() =>
    import("./page/MatchingDashboard/MatchingDashboard")
);

const SubProcessRecovery = React.lazy(() =>
    import("./page/SubProcessRecovery/SubProcessRecovery")
);

const ReportRFID = React.lazy(() => import("./page/ReportRFID/ReportRFID"));


const QualityTrackingDashboard = React.lazy(
    () => import("./page/QualityTrackingDashboard/QualityTrackingDashboard"),
);

//************************/ NON-DEPLOY /************************//





//************************/ NON-DEPLOY /************************//

// Component สำหรับตรวจสอบ path และเพิ่ม beforeunload event
const BeforeUnloadHandler = () => {
    const location = useLocation();

    useEffect(() => {
        const shouldAsk = location.pathname.toLowerCase().includes('audit');
        if (!shouldAsk) return;

        const handleBeforeUnload = (e) => {
            if (window.__skipAuditBeforeUnload) return;
            e.preventDefault();
            e.returnValue = 'ต้องการออกจากหน้านี้หรือไม่? ข้อมูลที่ยังไม่ได้บันทึกอาจสูญหาย';
            return 'ต้องการออกจากหน้านี้หรือไม่? ข้อมูลที่ยังไม่ได้บันทึกอาจสูญหาย';
        };

        // ลบ listener เก่าก่อน (ถ้ามี)
        window.removeEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [location.pathname]);

    return null;
};

const App = () => {
    return (
        <Router>
            <BeforeUnloadHandler />
            <div className="App">
                {/* ใช้ Suspense ในการกำหนด fallback ในกรณีที่โหลดคอมโพเนนต์ */}
                <Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                        {/*---------------------------- DEPLOYED ----------------------------*/}
                        <Route path="/" element={<Home />} />
                        <Route path="/Control_Room" element={<ControlRoom />} />
                        <Route
                            path="/SEWING_Efficiency/:bu/:dep"
                            element={<DashboardSewingComponent />}
                        />
                        <Route
                            path="/Quality_1/:bu"
                            element={<DashboardQuality1Component />}
                        />
                        <Route
                            path="/Quality_2/:bu"
                            element={<DashboardQuality2Component />}
                        />
                        <Route
                            path="/CuttingDashboard/:bu?"
                            element={<CuttingDashboard />}
                        />
                        <Route
                            path="/LoadData_Sewing"
                            element={<LoadDataSewing />}
                        />
                        <Route
                            path="/SettingHomePage"
                            element={<SettingHomePage />}
                        />
                        <Route
                            path="/ReportEndline"
                            element={<ReportEndline />}
                        />
                        <Route
                            path="/OnTimeDelivery/:bu"
                            element={<OnTimeDelivery />}
                        />

                        <Route
                            path="/SPFTracking/:param?"
                            element={
                                <Private>
                                    {/* <RequirePerm all={["28"]}> */}
                                    <SPFTracking />
                                    {/* </RequirePerm> */}
                                </Private>
                            }
                        />

                        <Route
                            path="/EndLine"
                            element={<EndlineMainComponent />}
                        />
                        <Route path="/Endline2/setup" element={<EndlineSetupPage />} />
                        <Route
                            path="/Endline2/:bu?/:line?"
                            element={<Endline2MainComponent />}
                        />
                        <Route path="/ReportCPI" element={<ReportCPI />} />
                        <Route path="/MasterPath" element={<MasterPath />} />

                        <Route
                            path="/Report_SewingPerformance"
                            element={<ReportSPFComponent />}
                        />
                        <Route
                            path="/SewingEfficiencyStatus/:bu/:dep"
                            element={<SewingEfficiencyStatus />}
                        />

                        <Route
                            path="/SubProcess-o/:bu?"
                            element={<SubProcess />}
                        />
                        <Route
                            path="/SubProcess/:bu?"
                            element={<Sm3FullScreenPage />}
                        />
                        <Route
                            path="/subprocessnew/:bu?"
                            element={<Sm3New3Page />}
                        />
                        <Route
                            path="/subprocessnew2/:bu?"
                            element={<Sm3NewPage />}
                        />
                        <Route
                            path="/subprocessnew3/:bu?"
                            element={<LegacySubprocessNew3Redirect />}
                        />
                        <Route
                            path="/subprocess-newlogic/:bu?"
                            element={<SubprocessNewLogicPage />}
                        />
                        <Route
                            path="/ReportFanatics"
                            element={<ReportFanatics />}
                        ></Route>
                        <Route
                            path="/Audit"
                            element={
                                <Private>
                                    <Audit />
                                </Private>
                            }
                        />
                        <Route
                            path="/auditnew"
                            element={
                                <Private>
                                    <Audit_2 />
                                </Private>
                            }
                        />

                        <Route path="/ScanEMB" element={<ScanEMB />}></Route>
                        <Route
                            path="/ScanPrinting"
                            element={<ScanPrinting />}
                        ></Route>
                        <Route
                            path="/Report_QC_System"
                            element={<Report_QC_System />}
                        ></Route>

                        <Route
                            path="/MatchingDashboard"
                            element={<MatchingDashboard />}
                        ></Route>

                        <Route
                            path="/SubProcessRecovery"
                            element={<SubProcessRecovery />}
                        ></Route>

                        <Route
                            path="/ReportRFID"
                            element={<ReportRFID />}
                        ></Route>

                        {/*---------------------------- NON-DEPLOY ----------------------------*/}
                        <Route
                            path="/QualityTrackingDashboard"
                            element={<QualityTrackingDashboard />}
                        ></Route>

                        {/*---------------------------- END ----------------------------*/}
                    </Routes>
                </Suspense>
            </div>
        </Router>
    );
};

export default App;
